export default __webpack_public_path__ + "static/media/02.888be374.svg";